import React from "react";
import styled from "styled-components";
import { useCurrentFrame } from "../use-current-frame";
import { interpolate } from "../interpolate";
import { spring } from "../Spring";

const Container = styled.span`
    display: inline-flex;
    overflow: hidden;
`;

const Holder = styled.span``;

function SlideUpAnimation(props) {
    const frame = useCurrentFrame();

    const { children, delay = 0 } = props;

    const animation = spring({
        frame: frame * 1.5 - delay,
        fps: (props.videoConfig || {}).fps || 30,
        config: {
            damping: 200,
        },
    });
    const translateY = interpolate(animation, [0, 1], [200, 0], {
        extrapolateRight: "clamp",
    });

    return (
        <Container>
            <Holder
                style={{
                    transform: `translate(0px, ${translateY}px)`,
                }}
            >
                {children}
            </Holder>
        </Container>
    );
}

export default React.memo(SlideUpAnimation);
